import {Component, OnInit} from '@angular/core';
import {ChangeRequestVO} from 'common-domain';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {ChangeRequestService, DomainService} from 'common-domain';

@Component({
    selector: 'app-request-details',
    templateUrl: './request-details.component.html',
    styleUrls: ['./request-details.component.scss'],
    standalone: false
})
export class RequestDetailsComponent implements OnInit {

  changeRequestVO: ChangeRequestVO = {};
  requestID: string;

  constructor(private route: ActivatedRoute, private router: Router, private titleService: Title, private domainService: DomainService, private changeRequestService: ChangeRequestService) {
  }

  ngOnInit() {
    this.titleService.setTitle('Change Request Details');
    this.getInputData();
  }


  getInputData() {
    this.route.params.subscribe(params => {
      this.requestID = params['requestNumber'];
      if (this.requestID) {
        this.changeRequestService.getChangeRequestDetails(this.requestID).subscribe(data => {
          this.changeRequestVO = data;
        }, error => {

        }, () => {

        });
      } else {
        this.router.navigateByUrl('/user/home');
      }
    });
  }

}
